import React from "react";

const About = () => {
  return (
    <div name="about" className="w-full min-h-screen bg-[#0a192f] text-gray-300 scroll-mt-20">
      <div className="flex flex-col justify-center items-center w-full h-full">
        <div className="max-w-[1000px] w-full grid grid-cols-2 gap-8">
          <div className="pb-8 pl-4">
            <p className="text-4xl font-bold inline border-b-4 border-violet-600">
              About
            </p>
          </div>
          <div></div>
        </div>
        <div className="max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4">
          <div className="text-4xl font-bold">
            <p>
              Experienced DevOps/SRE Professional with a Bachelor's Degree in
              Computer Science
            </p>
          </div>
          <div>
            <p>
              I have a passion for problem-solving, writing code, and
              continuously expanding my skills and knowledge. I enjoy
              exploring new technologies, including AI-powered tools, to
              streamline workflows, automate processes, and improve
              productivity. I place strong emphasis on building secure,
              reliable, and scalable systems, integrating security best
              practices and leveraging modern tools to handle dynamic
              workloads efficiently. I also value observability and
              monitoring as essential for maintaining system health,
              ensuring that data is collected and analyzed intelligently
              to identify critical events promptly while minimizing noise.
              Additionally, I enjoy collaborating with others and sharing
              my knowledge.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
